import React, { Fragment } from 'react';
import { Row, Card, CardBody, CardTitle, Button } from 'reactstrap';
import { Colxx } from '../../common/CustomBootstrap';
import GlideComponent from '../../carousel/GlideComponent';
import IntlMessages from '../../../helpers/IntlMessages';
import moment from 'moment';
import {
  faImages,
  faEdit,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Translate from '../../../helpers/Translate';

const BasicCarouselItem = ({ index, url, caption, isTranslate, translateLang }) => {
  return (
    <div className="glide-item">
      <Card className="flex-row">
        <div className="w-100 position-relative">
          <img className="card-img-left" src={url} alt={caption[index]} />
          <span
            className={`badge badge-pill badge-primary
                     position-absolute badge-top-left`}
          >
            {isTranslate === true ? <Translate input={caption} lang={translateLang}></Translate> :
              caption}
          </span>
        </div>
      </Card>
    </div>
  );
};

const Showing = ({ sildes, isTranslate, translateLang }) => {
  const SildeItem = JSON.parse(sildes.text);
  //console.log(SildeItem.length);
  return (
    <Fragment>
      {SildeItem.length === 1 &&
        SildeItem.map((element1, index) => {
          return (
            <div key={index}>
              <BasicCarouselItem
                translateLang={translateLang}
                isTranslate={isTranslate}
                index={index}
                url={element1.url}
                caption={element1.caption === null ? "" : element1.caption}
              />
            </div>
          );
        })}
      {SildeItem.length > 1 && (
        <GlideComponent
          settings={{
            gap: 5,
            perView: 2,
            keyboard: false,
            // type: 'slider',
            rewind: false,
            // breakpoints: {
            //   600: { perView: 1 },
            //   1400: { perView: 2 },
            // },
          }}
        >
          {SildeItem.map((element1, index) => {
            return (
              <div key={index}>
                <BasicCarouselItem
                  index={index}
                  url={element1.url}
                  caption={element1.caption === null ? "" : element1.caption}
                />
              </div>
            );
          })}
        </GlideComponent>
      )}
    </Fragment>
  );
};
export default Showing;
